import http from 'utils/http';

export const createCategory = ({ name, menuId }) => http.post(
  `v1/organizations/{{organizationId}}/global-menus/${menuId}/categories/`,
  { name },
).then((res) => res.data);
